import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useCustomer } from '../../context/CustomerContext';
import AccountLayout from './AccountLayout';

const AccountProtectedRoute = () => {
  const { isAuthenticated, loading } = useCustomer();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-700"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <AccountLayout>
      <Outlet />
    </AccountLayout>
  );
};

export default AccountProtectedRoute;
